import { loadScript } from '@/helpers/Hotjar/scriptLoader';

export const initHotjar = (): void => {
  if (window.hj) {
    return;
  }

  // Register necessary configuration
  window.hj = (...args: any[]) => {
    if (!window.hj.q) {
      window.hj.q = [];
    }
    window.hj.q.push(args);
  };

  window._hjSettings = {
    hjid: import.meta.env?.VUE_APP_HOTJAR_ID,
    hjsv: import.meta.env?.VUE_APP_HOTJAR_VERSION,
  };

  const hotjarUrl = import.meta.env?.VUE_APP_HOTJAR_URL ?? '';

  loadScript(hotjarUrl).catch(() => console.log('Failed to load Hotjar script'));
};
